import { ConfluenceIcon } from '@atlaskit/logo';

import { Journeys } from '@atlassiansox/cross-flow-support/cross-flow-api-internals';

import { Targets } from '@atlassiansox/cross-flow-support/cross-flow-base-types';

import {
	AtlasSideNavAppRecommendationMenuItem,
	type ComponentProps,
} from '@post-office/browser--growth/components/atlas-side-nav-growth-item';

import { type JSX } from 'react/jsx-runtime';

const ProductLogo = () => <ConfluenceIcon size="xsmall" appearance="brand" />;

export const AtlasSideNavRecommendationConfluence = ({ ...props }: ComponentProps): JSX.Element => {
	return (
		<AtlasSideNavAppRecommendationMenuItem
			{...props}
			appName={'Confluence'}
			logo={<ProductLogo />}
			targetProduct={Targets.CONFLUENCE}
			journeyType={Journeys.DECIDE}
		/>
	);
};
